/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import AppointmentAction from 'DesignSystem/AppointmentAction/index'
import CheckInAction from 'DesignSystem/CheckInAction/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/AppointmentActions/CheckInPatient/Content"
  
}) {
let appointmentActionsAppointmentBookingValueData = fromData.useDataValue({ viewPath,
context: 'appointment_actions',
path: 'appointment_booking',
})
let globalCurrentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location._id',
})
let appointmentActionsPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_actions',
path: 'patient.id',
})
  return (<React.Fragment
>
<CheckInAction
  viewPath={`${viewPath}/CheckInAction`}
 data="appointment_actions.appointment_booking"
 appointmentBooking={appointmentActionsAppointmentBookingValueData}
 data="global.current_location._id"
 locationId={globalCurrentLocationIdValueData}
 data="appointment_actions.patient.id"
 patientId={appointmentActionsPatientIdValueData}
>
{childProps => (
<AppointmentAction
{...childProps}
  viewPath={`${viewPath}/AppointmentAction`}
 text="Check in patient"
/>
)}
</CheckInAction>
{children}
</React.Fragment>)
}